import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { ProductTemplate } from '@app_modules/product-templates/product-template';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';

export interface UWData {
  text: string;
}

interface Response extends BackendResponse {
  uwdata: UWData;
}

export interface FilePayload {
  files: Array<File>;
  prompt: string;
}

export function useUwAction(form: UseFormReturn<FilePayload>) {
  const {trans} = useTrans();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: FilePayload) => createUwAction(payload),
    onSuccess: async () => {
      //await queryClient.invalidateQueries({queryKey: DatatableDataQueryKey('product-templates')});
      toast(trans(message('UW processed')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function createUwAction(payload: FilePayload) {
    return apiClient.post<Response>('chats/uw-demo', FilePayloadToFormData(payload), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(r => r.data);
}


export function FilePayloadToFormData(
  payload: Partial<FilePayload>,
) {
  const formData = new FormData();
  
  if (payload.prompt != undefined) {
    formData.append("prompt", payload.prompt);
  }
  
  if (payload.files) {
    payload.files.forEach((file) => {
      formData.append("files[]", file);
    });
  }
  
  return formData;
}
